<template>
  <div class="videoList_phone">
    <div class="container">
      <!-- logo start -->
      <div class="logo">
        <img src="/statics/image/phone/logo.png" class="thumb" alt />
      </div>
      <!-- logo end -->
      <!-- menu start -->
      <div class="menu flex">
        <div class="item cur" @click="toPage(-1,-1)">首页</div>
        <div class="item" @click="toPage(11,indexa)">新区概况</div>
        <div class="item" @click="toPage(12,indexb)">新区要闻</div>
        <div class="item" @click="toPage(13,indexc)">招商引资</div>
      </div>
      <!-- menu end -->
      <!-- content start -->
      <div class="content bgsky">
        <!-- 更多精彩 start -->
        <div class="floor">
          <div class="title-group flex-between">
            <div class="title">衡水高新区新闻</div>
          </div>
          <div class="video-groupA">
            <div
              class="item flex"
              v-for="(item,index) in videolist"
              :key="index"
              @click="toPlay(item.video_id)"
            >
              <div class="info">
                <div class="name multi-ellipsis">
                  <!-- <span class="fa fa-video-camera" style="padding-right:15px;"></span> -->
                  <i class="el-icon-video-camera-solid"></i>
                  {{item.title}}
                </div>
              </div>
            </div>
          </div>
          <!-- page start -->
          <div class="fenyep clearfix">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pages.size"
              layout="prev, pager, next"
              :total="newsTotal"
            ></el-pagination>
          </div>
          <!-- page end -->
        </div>
        <!-- 更多精彩 end -->
      </div>
      <!-- content end -->
      <!-- footer start -->
      <div class="footer">
        <p>主办：河北衡水高新技术产业开发区</p>
        <p>网站标识：1311000037</p>
        <p>公安备案：13110802000107</p>
        <p>地址：衡水市永兴西路1988号</p>
        <a href="http://beian.miit.gov.cn/" class="map">冀ICP备16022288号-1 网站地图</a>
        <p>技术支持：河北中信联信息技术有限公司</p>
        <img src="/statics/image/phone/gov.png" class="gov" alt />
      </div>
      <!-- footer end -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cateId: "",
      currentPage: 1, //当前页数
      pages: {
        page: 1,
        size: 20
      },
      newsTotal: 0, //总条数
      videolist: [],
      catelist: [],
      indexa: "",
      indexb: "",
      indexc: ""
    };
  },
  created() {
    this.cateId = this.$route.query.cate_id;
    function mobileskip() {
      var mobileAgent = new Array(
        "iphone",
        "ipod",
        "ipad",
        "android",
        "mobile",
        "blackberry",
        "webos",
        "incognito",
        "webmate",
        "bada",
        "nokia",
        "lg",
        "ucweb",
        "skyfire"
      );
      var browser = navigator.userAgent.toLowerCase();
      var isMobile = false; //记录是否移动端
      for (var i = 0; i < mobileAgent.length; i++) {
        if (browser.indexOf(mobileAgent[i]) != -1) {
          isMobile = true;
          break;
        }
      }
      return isMobile;
    }
    if (mobileskip()) {
      this.getVideo();
      this.getNav();
      // 移动端
    } else {
      this.$router.push({
        path: "/video",
        query: {
          cate_id: this.cateId
        }
      });
    }
  },
  methods: {
    toPath(url, obj) {
      if (this.$route.fullPath == url) {
        return;
      }
      if (this.$route.path == url) {
        this.$router.push({
          path: url,
          query: obj
        });
        return;
      }
      this.$router.push({
        path: url,
        query: obj
      });
    },
    toPage(id, index) {
      if (id == "-1") {
        this.toPath("/", {});
      } else {
        this.toPath("/xqNews", { id: id, index: index });
      }
    },
    getNav() {
      var that = this;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          that.catelist = res.result.all_cate;
          for (var i in that.catelist) {
            if (that.catelist[i].id == "11") {
              that.indexa = i;
            } else if (that.catelist[i].id == "12") {
              that.indexb = i;
            } else if (that.catelist[i].id == "13") {
              that.indexc = i;
            }
          }
        //   console.log(that.indexa,that.indexb,that.indexc);
        }
      });
    },
    toPlay(id) {
      this.$router.push({
        path: "/videoPlayPhone",
        query: {
          id: id
        }
      });
    },
    getVideo() {
      var that = this;
      var ps = {
        cate_id: that.cateId,
        page: that.pages.page,
        size: that.pages.size
      };
      that.$api.index.videolist(ps).then(function(res) {
        if (res.code == 200) {
          that.videolist = res.result.list;
          that.newsTotal = res.result.total;
        }
      });
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      this.pages.page = val;
      this.getVideo();
      $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    }
  }
};
</script>

<style>
</style>